import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"],
})
export class ResetPasswordComponent implements OnInit {
  model = { password: "", confirm_password: "", token: "" };
  resetToken: any;
  forgotToken: any;
  passwordType: any = "password";
  isLoading = false;
  confirmPasswordType: any = "password";
  constructor(
    private route: ActivatedRoute,
    private service: AuthService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.model.token = params.token;
    });
  }

  submit(form) {
    if (form) {
      this.isLoading = true ;
      this.service.resetPassword(this.model).subscribe(
        (res) => {
          this.isLoading = false ;
          this.toastr.success(res.message, "Success!",{
            closeButton: true,
          });
          this.router.navigate(["/login"])
        },
        (err) => {
          this.isLoading = false ;
          if (err.status === 422) {
            this.toastr.error(err.datas.message, "OOPS!",{
              closeButton: true,
            });
          } else {
            this.toastr.error(err.datas.message, "OOPS!",{
              closeButton: true,
            });
          }
        }
      );
    }
  }

  changePasswordType(type: any): void {
    if (type === "password") {
      if (this.passwordType === "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    } else if (type === "confirmPassword") {
      if (this.confirmPasswordType === "password") {
        this.confirmPasswordType = "text";
      } else {
        this.confirmPasswordType = "password";
      }
    }
  }
}
